<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
        <span v-html="deviceNameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" />
        <span v-html="deviceCodeVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备类型：</span>
        </div>
        <el-select v-model="deviceType" size="small" style="width: 280px">
          <el-option v-for="item in deviceTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂商：</span>
        </div>
        <el-select v-model="deviceManufacturer" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelName" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">接入协议：</span>
        </div>
        <el-select v-model="protocolType" size="small" style="width: 280px">
          <el-option v-for="item in protocolTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="protocolType === '国标协议'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">国标ID：</span>
        </div>
        <el-input v-model="gbId" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备账号：</span>
        </div>
        <el-input v-model="userName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备密码：</span>
        </div>
        <el-input v-model="password" type="password" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备用途：</span>
        </div>
        <el-select v-model="purpose" size="small" style="width: 280px">
          <el-option v-for="item in purposeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">是否报警：</span>
        </div>
        <div style="width: 220px;line-height: 32px;display: inline-block;">
          <el-switch
            v-model="whetherToAlarm"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备所在楼栋：</span>
        </div>
        <el-select v-model="buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePerson"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="memo" size="small" style="width: 280px" />
      </div>


      <!--<div class="flex-align-center margin-top-12" style="margin-left: 22px;">-->
        <!--<span style="color: red;">*</span>-->
        <!--<span class="margin-right-16">设备组织：</span>-->
        <!--<input-tree class="input-tree"-->
                    <!--:fetch="config.tree.fetch"-->
                    <!--:default-value="1"-->
                    <!--@input="handleEntitySelected"-->
        <!--/>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import InputTree from "../../../components/common/inputs/input-tree";
import { pattern } from "../../../utils/regular";
import { api } from "../../api/VideoServices";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import { bus } from "../../../utils/bus";
// let a = document.getElementsByClassName()

export default {
  components: {
    ButtonConfirmNext,
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: "video-device-add",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧监控",
            name: "video-device"
          },
          {
            value: "设备管理"
          }
        ]
        // tree: {
        //   fetch: () => api.getBusinessTreeList().then(list => {
        //     list.forEach(tree => {
        //       tree._value = tree.id
        //       tree._label = tree.label = tree.businessEntityName
        //     })
        //     return list
        //   })
        // }
      },
      mainTitle: "添加设备",
      subheading: "",
      deviceName: "",
      deviceNameVer: "",
      deviceCode: "",
      deviceCodeVer: "",
      deviceType: "11",
      deviceTypeList: [
        { code: "11", name: "摄像头" },
        { code: "12", name: "平台" }
      ],
      deviceManufacturer: "",
      deviceManufacturerList: [],
      deviceModelName: "",
      deviceModelNameList: [],

      responsiblePerson: "",
      responsiblePersonList: [],
      responsiblePersonVer: "",
      hasParent: false,

      hasResponsiblePerson: true,
      roomCode: "",
      roomNumber: "",
      deviceNameHttp: false,
      deviceCodeHttp: false,
      fetchDetail: null,
      organizationCode: "",
      organizationName: "",
      userName: "",
      password: "",
      buildingCode: "",
      buildingName: "",
      buildingList: [],
      memo: "",
      protocol: "",
      purpose: "",

      whetherToAlarm: false,

      protocolType: "国标协议",
      protocolTypeList: [
        {
          code: "国标协议",
          name: "国标协议"
        },
        {
          code: "主动注册",
          name: "主动注册"
        },
        {
          code: "大华云睿",
          name: "大华云睿"
        },
        {
          code: "海康云眸",
          name: "海康云眸"
        }
      ],
      purposeList: [
        {
          code: "客流统计",
          name: "客流统计"
        },
        {
          code: "人脸识别",
          name: "人脸识别"
        },
        {
          code: "视频监控",
          name: "视频监控"
        },
        {
          code: "消防通道",
          name: "消防通道"
        },
        {
          code: "高空抛物",
          name: "高空抛物"
        },
        {
          code: "电动车",
          name: "电动车"
        },

        {
          code: "配电房",
          name: "配电房"
        }
      ],
      gbId: ""
    };
  },
  created() {
    this.organizationCode = window.sessionStorage.getItem(
      "videoOrganizationCode"
    );
    this.organizationName = window.sessionStorage.getItem(
      "videoOrganizationName"
    );
    this.getAllDeviceManufacture();
    this.getBuildingList();
    this.remoteMethod();
  },
  methods: {
    // 获取楼栋列表
    getBuildingList() {
      this.$axios
        .post(`${api.getBuildingList}`, {})
        .then(res => {
          let data = res.data.data;
          this.buildingList = data;
        })
        .catch(errorHandler("获取楼栋列表失败"));
    },
    // 获取设备厂家
    getAllDeviceManufacture() {
      this.$axios
        .post(`${api.getAllDeviceManufacture}`, {
          moduleCode: "5",
          deviceType: this.deviceType
        })
        .then(res => {
          this.deviceManufacturerList = res.data.data;
          if (this.deviceManufacturerList.length > 0) {
            this.deviceManufacturer = res.data.data[0].code;
            this.getAllDeviceType();
          }
        })
        .catch(errorHandler("获取设备厂家失败"));
    },
    // 获取设备型号
    getAllDeviceType() {
      this.$axios
        .post(`${api.getAllDeviceType}`, {
          moduleCode: "11",
          deviceType: this.deviceType,
          deviceManufactureCode: this.deviceManufacturer
        })
        .then(res => {
          let data = res.data.data;
          this.deviceModelNameList = data;
          if (this.deviceModelNameList.length > 0) {
            this.deviceModelName = data[0].code;
          }
        })
        .catch(errorHandler("获取设备型号失败"));
    },

    // 查询园区管理员
    getResponsiblePersonList(searchKey) {
      this.$axios
        .post(`${api.getResponsiblePersonList}`, {
          searchKey: searchKey || ""
        })
        .then(res => {
          let list = res.data.data;
          list.forEach(it => {
            it._value = it.code;
            it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`;
          });
          this.responsiblePersonList = list;
        });
    },

    remoteMethod(query) {
      this.getResponsiblePersonList(query);
    },

    addNext() {
      if (!this.deviceName) {
        nError("请输入设备名称");
        return false;
      }
      if (!this.deviceCode) {
        nError("请输入设备编号");
        return false;
      }
      if (!this.userName) {
        nError("请输入设备账户");
        return false;
      }
      if (!this.purpose) {
        nError("请输入设备用途");
        return false;
      }
      if (!this.password) {
        nError("请输入设备密码");
        return false;
      }
      if (this.protocolType === "国标协议" && !this.gbId) {
        nError("请输入国标ID");
        return false;
      }
      let obj = {
        deviceName: this.deviceName,
        deviceCode: this.deviceCode,
        deviceManufacturerCode: this.deviceManufacturer,
        deviceManufacturerName: "",
        deviceModelCode: this.deviceModelName,
        deviceModelName: "",
        organizationCode: this.organizationCode,
        organizationName: this.organizationName,
        responsiblePersonCode: this.responsiblePerson,
        responsiblePersonName: "",
        deviceManufacturer: this.deviceManufacturer,
        deviceType: this.deviceType,
        buildingCode: this.buildingCode,
        buildingName: this.buildingName,
        userName: this.userName,
        password: this.password,
        memo: this.memo,
        purpose: this.purpose,

        protocolType: this.protocolType,
        gbId: this.gbId,
        whetherToAlarm: this.whetherToAlarm
      };
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name;
        }
      });
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePerson) {
          obj.responsiblePersonName = v._label;
          obj.responsiblePersonCode = v.code;
        }
      });
      this.buildingList.map(v => {
        if (v.code === this.buildingCode) {
          obj.buildingName = v.name;
        }
      });
      this.$axios
        .post(`${api.addVideoDevice}`, obj)
        .then(() => {
          nSuccess("添加成功");
          this.deviceName = "";
          this.deviceCode = "";
          this.responsiblePerson = "";
        })
        .catch(errorHandler("添加设备失败"));
    },
    add() {
      if (!this.deviceName) {
        nError("请输入设备名称");
        return false;
      }
      if (!this.deviceCode) {
        nError("请输入设备编号");
        return false;
      }
      if (!this.userName) {
        nError("请输入设备账户");
        return false;
      }
      if (!this.purpose) {
        nError("请输入设备用途");
        return false;
      }
      if (!this.password) {
        nError("请输入设备密码");
        return false;
      }
      if (this.protocolType === "国标协议" && !this.gbId) {
        nError("请输入国标ID");
        return false;
      }
      let obj = {
        deviceName: this.deviceName,
        deviceCode: this.deviceCode,
        deviceManufacturerCode: this.deviceManufacturer,
        deviceManufacturerName: "",
        deviceModelCode: this.deviceModelName,
        deviceModelName: "",
        organizationCode: this.organizationCode,
        organizationName: this.organizationName,
        responsiblePersonCode: this.responsiblePerson,
        responsiblePersonName: "",
        deviceManufacturer: this.deviceManufacturer,
        deviceType: this.deviceType,
        buildingCode: this.buildingCode,
        buildingName: this.buildingName,
        userName: this.userName,
        password: this.password,
        memo: this.memo,
        purpose: this.purpose,

        protocolType: this.protocolType,
        gbId: this.gbId,
        whetherToAlarm: this.whetherToAlarm
      };
      this.deviceManufacturerList.map(v => {
        if (v.code === this.deviceManufacturer) {
          obj.deviceManufacturerName = v.name;
        }
      });
      this.deviceModelNameList.map(v => {
        if (v.code === this.deviceModelName) {
          obj.deviceModelName = v.name;
        }
      });
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePerson) {
          obj.responsiblePersonName = v._label;
          obj.responsiblePersonCode = v.code;
        }
      });
      this.buildingList.map(v => {
        if (v.code === this.buildingCode) {
          obj.buildingName = v.name;
        }
      });
      this.$axios
        .post(`${api.addVideoDevice}`, obj)
        .then(() => {
          nSuccess("添加成功");
          this.strategyCenter();
        })
        .catch(errorHandler("添加失败"));
    },
    strategyCenter() {
      this.$router.push({
        name: "video-device"
      });
    }
  },
  watch: {
    deviceType(v) {
      this.getAllDeviceManufacture();
    },
    deviceName(v) {
      let ptn = pattern.basicAndCN.test(v);
      if (!ptn) {
        this.deviceNameVer =
          '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>';
        this.deviceNameHttp = false;
      } else {
        this.deviceNameVer = "<span></span>";
        this.deviceNameHttp = true;
      }
    },
    deviceCode(v) {
      let ptn = pattern.abd123.test(v);
      if (!ptn) {
        this.deviceCodeVer =
          '<span style="color: red;">只允许输入字母，数字</span>';
        this.deviceCodeHttp = false;
      } else {
        this.deviceCodeVer = "<span></span>";
        this.deviceCodeHttp = true;
      }
    },

    deviceManufacturer(v) {
      if (v === "100080") {
        this.hasParent = true;
      }
      this.getAllDeviceType();
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/VideoServices/VideoDevice/VideoDeviceAdd.vue